const toNumber = (val: any) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    loggable: {
      name: 'รายละเอียด',
      width: '1fr',
      class: 'text-left',
      filter: (val: any, row: any) => {
        if (row.item.loggable.material.brand) return `[${row.item.loggable.material?.brand}] ${row.item.loggable.material?.code} ${row.item.loggable.material?.name}`;
        return `${row.item.loggable.material?.name}`;
      },
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: 'text-right',
      filter: (val: any, row: any) => `${toNumber(row.item.loggable?.filled_amount)} ${row.item.loggable.purchase_unit || row.item.loggable.material?.unit}`,
    },
  },

  sortable: [
    'type',
    'code',
    'updated_at',
  ],
};
